import React from 'react';

const TTL_MS = 4000;

let typing: Record<string, Record<string, number>> = {};
const listeners = new Set<() => void>();
const emit = () => listeners.forEach((listener) => listener());

export function chatTypingSeen(channelId: string, userId: string): void {
    typing = { ...typing, [channelId]: { ...(typing[channelId] ?? {}), [userId]: Date.now() + TTL_MS } };
    emit();
    window.setTimeout(() => {
        const until = typing[channelId]?.[userId];
        if (until && until <= Date.now()) {
            const { [userId]: _gone, ...rest } = typing[channelId];
            typing = { ...typing, [channelId]: rest };
            emit();
        }
    }, TTL_MS + 50);
}

export function chatTypingStop(channelId: string, userId: string): void {
    if (!typing[channelId]?.[userId]) return;
    const { [userId]: _gone, ...rest } = typing[channelId];
    typing = { ...typing, [channelId]: rest };
    emit();
}

const subscribe = (listener: () => void) => {
    listeners.add(listener);
    return () => { listeners.delete(listener); };
};

export function useChatTyping(channelId: string | null): string[] {
    const snapshot = React.useSyncExternalStore(subscribe, () => typing);
    return React.useMemo(() => {
        const entries = channelId ? snapshot[channelId] ?? {} : {};
        const now = Date.now();
        return Object.entries(entries).filter(([, until]) => until > now).map(([userId]) => userId);
    }, [snapshot, channelId]);
}
